<div class="cardLayout">
    <!-- Header: title + spinner + reload -->
    <div class="d-flex flex-row flex-wrap align-items-center psic-gap-4">
        <h4>{{ title }}</h4>
        <!-- <div [class.d-none]="!isLoading" class="spinner-border spinner-border-sm text-primary" role="status" ></div> -->
        <app-animation
            [class.d-none]="!isLoading"
            [src]="'dots_loader.json'"
            [loop]="true"
            [autoplay]="true"
        ></app-animation>
        @if (!isLoading) {
        <mat-icon
            svgIcon="reload"
            class="reload p1-50-color"
            (click)="retry.emit(); $event.stopPropagation()"
        ></mat-icon>
        } @if (!failed && noDataMessage && fields.length === 0 && sections.length === 0 && items.length === 0) {
        <lib-alert
            style="width: fit-content"
            [class.d-none]="isLoading"
            [alertText]="noDataMessage"
            [alertTheme]="'success'"
            [alertType]="'small'"
        ></lib-alert>
        }
    </div>

    <!-- Reusable: Column headers -->
    <ng-template #columnHeaders>
        <div class="row">
            @for (col of columns; track $index) {
            <div [class]="$index === 0 ? 'col caption-bold' : 'col-3 caption-bold text-end'">{{ col }}</div>
            }
        </div>
    </ng-template>

    <!-- Reusable: Field row (with columns) -->
    <ng-template #fieldRowWithColumns let-field>
        <div class="row">
            <div class="col caption-bold">{{ field.caption }}</div>
            @if (field.descriptionHtml || field.description) {
            <div class="col-3 d-flex flex-column align-items-end">
                <h6>{{ field.value }}</h6>
                <div class="disclaimer" [innerHTML]="field.descriptionHtml || field.description"></div>
            </div>
            } @else { @if (field.value) {
            <div class="col-3 caption text-end">
                @if (field.isTag) {
                <lib-tag
                    [tagText]="field.value"
                    [tagTheme]="field.tagTheme || 'neutralAq'"
                    [tagType]="'lineFill'"
                ></lib-tag>
                } @else { {{ field.value }} }
            </div>
            } @if (field.premium) {
            <div class="col-3 caption text-end">{{ field.premium }}</div>
            } }
        </div>
    </ng-template>

    <!-- Reusable: Field row (without columns) -->
    <ng-template #fieldRowNoColumns let-field>
        @if (field.hasSeparator) {
        <div class="separator"></div>
        }
        <div class="d-flex flex-row justify-content-between align-items-start" style="gap: 4px">
            @if (field.captionHtml) {
            <div [innerHTML]="field.captionHtml"></div>
            } @else {
            <div class="caption-bold d-flex align-items-center psic-gap-1">
                {{ field.caption }}@if (field.actionIcon) {
                <mat-icon
                    [svgIcon]="field.actionIcon"
                    class="card-description mat-icon-16"
                    [class.p1-50-color]="!field.actionIconDisabled"
                    [style.opacity]="field.actionIconDisabled ? '0.35' : '1'"
                    [style.cursor]="field.actionIconDisabled ? 'not-allowed' : 'pointer'"
                    style="flex-shrink: 0"
                    (click)="!field.actionIconDisabled && onActionIconClick(field, $event)"
                ></mat-icon>
                }
            </div>
            } @if (field.valueIcon) {
            <mat-icon [svgIcon]="field.valueIcon" class="card-description mat-icon-32"></mat-icon>
            } @else if (field.isUpdating) {
            <div class="d-flex flex-row align-items-center gap-1">
                <span class="caption dg_mg-60-color">Updating</span>
                <app-animation
                    [src]="'dots_loader.json'"
                    [loop]="true"
                    [autoplay]="true"
                    style="width: 48px; height: 32px; display: inline-flex"
                ></app-animation>
            </div>
            } @else if (field.valueHtml || field.descriptionHtml || field.description) {
            <div class="d-flex flex-column align-items-end">
                @if (field.valueHtml) {
                <p [innerHTML]="field.valueHtml"></p>
                } @else if (field.boldValue) {
                <h6>{{ field.value }}</h6>
                } @else {
                <h5>{{ field.value }}</h5>
                }
                <div class="disclaimer" [innerHTML]="field.descriptionHtml || field.description"></div>
            </div>
            } @else { @if (field.value && !field.premium) { @if (field.boldValue) {
            <h6>{{ field.value }}</h6>
            } @else {
            <div
                class="d-flex flex-row align-items-center gap-2 justify-content-end"
                style="flex-wrap: wrap; overflow: visible; flex: 1; text-align: end"
            >
                @if (field.isTag) {
                <lib-tag
                    [tagText]="field.value"
                    [tagTheme]="field.tagTheme || 'default'"
                    [tagType]="'lineFill'"
                ></lib-tag>
                } @else { @if (field.link) {
                <a [href]="field.link" target="_blank" class="producer-link caption">{{ field.value }}</a>
                } @else {
                <span
                    [class.error-value]="field.errorTag"
                    class="caption d-flex align-items-center psic-gap-1"
                    style="
                        overflow-wrap: anywhere;
                        word-break: break-all;
                        min-width: 0;
                        flex-shrink: 1;
                        text-align: end;
                    "
                    >{{ field.value }}</span
                >
                } @if (field.successTag) {
                <lib-tag
                    style="flex-shrink: 0"
                    [tagText]="field.successTag"
                    [tagTheme]="'success'"
                    [tagType]="'lineFill'"
                ></lib-tag>
                } @else if (field.warningTag) {
                <lib-tag
                    style="flex-shrink: 0"
                    [tagText]="field.warningTag"
                    [tagTheme]="'warning'"
                    [tagType]="'lineFill'"
                ></lib-tag>
                } @else if (field.errorTag) {
                <lib-tag
                    style="flex-shrink: 0"
                    [tagText]="field.errorTag"
                    [tagTheme]="'error'"
                    [tagType]="'lineFill'"
                ></lib-tag>
                } }
            </div>
            } } @if (!field.value && field.premium) {
            <div class="caption text-end">{{ field.premium }}</div>
            } @if (field.value && field.premium) {
            <div class="col-4 caption text-end">{{ field.value }}</div>
            <div class="col-4 caption text-end">{{ field.premium }}</div>
            } }
        </div>
    </ng-template>

    <!-- Reusable: Fields list -->
    <ng-template #fieldsList let-fields>
        @for (field of fields; track $index) { @if (hasColumns) {
        <ng-container *ngTemplateOutlet="fieldRowWithColumns; context: { $implicit: field }"></ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="fieldRowNoColumns; context: { $implicit: field }"></ng-container>
        } }
    </ng-template>

    <ng-template #collapsibleSectionFields let-section="section">
        @for (field of getVisibleFields(section); track $index) { @if (field.children?.length) {
        <div class="row align-items-center">
            <div class="col caption">{{ field.caption }}</div>
            <div class="col-2"></div>
            <div class="col-2"></div>
            <div class="col d-flex justify-content-end field-toggle">
                <lib-button
                    [buttonType]="'borderless'"
                    [buttonText]="field.value ?? ''"
                    [libIcon]="isFieldExpanded(getSectionKey(section), $index) ? 'chevron-up' : 'chevron-down'"
                    (callback)="toggleField(getSectionKey(section), $index)"
                ></lib-button>
            </div>
        </div>

        @if (isFieldExpanded(getSectionKey(section), $index)) { @for (child of field.children; track $index) {
        <div class="row">
            <div class="col caption"></div>
            <div class="col-2 caption text-end psic-px-1">{{ child.description }}</div>
            <div class="col-2 caption text-end psic-px-1">{{ child.typeCode }}</div>
            <div class="col caption-bold text-end psic-pr-8">{{ child.premium }}</div>
        </div>
        }
        <div class="separator"></div>
        } } @else { @if (section.columns?.length || hasColumns) {
        <ng-container *ngTemplateOutlet="fieldRowWithColumns; context: { $implicit: field }"></ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="fieldRowNoColumns; context: { $implicit: field }"></ng-container>
        } } }
    </ng-template>

    <!-- Error state -->
    @if (failed) {
    <lib-alert
        style="width: fit-content"
        [alertText]="'Service unavailable'"
        [alertTheme]="'error'"
        [alertType]="'small'"
    ></lib-alert>
    } @if (!failed && (hasSections || fields.length > 0 || hasItems)) {
    <div [class.d-none]="isLoading" class="d-flex flex-column psic-gap-5">
        <!-- Custom content projection -->
        <ng-content></ng-content>

        <!-- Simple fields (no sections) -->
        @if (!hasSections && fields.length > 0) { @if (isCompact()) {
        <div class="d-flex flex-column psic-gap-6">
            <div class="d-flex flex-row psic-gap-4 align-items-center">
                @if (icon) {
                <mat-icon [svgIcon]="icon" class="card-description mat-icon-64"></mat-icon>
                } @if (subtitle) {
                <h6>{{ subtitle }}</h6>
                }
            </div>
            <ng-container *ngTemplateOutlet="fieldsList; context: { $implicit: fields }"></ng-container>
        </div>
        } @else {
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-column psic-gap-4">
                @if (icon) {
                <mat-icon [svgIcon]="icon" class="card-description mat-icon-64"></mat-icon>
                } @if (subtitle) {
                <h6>{{ subtitle }}</h6>
                }
            </div>
            <div class="d-flex flex-column psic-gap-4 right-content">
                @if (hasColumns) {
                <ng-container *ngTemplateOutlet="columnHeaders"></ng-container>
                }
                <ng-container *ngTemplateOutlet="fieldsList; context: { $implicit: fields }"></ng-container>
            </div>
        </div>
        } }

        <!-- Multi-section layout -->
        @if (hasSections) { @if (isCompact()) { @for (section of sections; track $index) {
        <div class="d-flex flex-column psic-gap-6">
            <div class="d-flex flex-row psic-gap-4 align-items-center">
                <mat-icon [svgIcon]="section.icon" class="card-description mat-icon-64"></mat-icon>
                <h6>{{ section.title }}</h6>
            </div>
            <ng-container *ngTemplateOutlet="collapsibleSectionFields; context: { section: section }"></ng-container>
            @if (shouldShowToggle(section)) {
            <div class="d-flex justify-content-start w-100">
                <lib-button
                    [buttonType]="'borderless'"
                    [buttonText]="getToggleLabel(section)"
                    [libIcon]="getToggleIcon(section)"
                    (callback)="toggleSection(section)"
                ></lib-button>
            </div>
            }
        </div>
        @if (!$last || hasItems) {
        <div class="separator"></div>
        } } } @else { @if (hasColumns) {
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-column"></div>
            <div class="d-flex flex-column psic-gap-5 right-content">
                <ng-container *ngTemplateOutlet="columnHeaders"></ng-container>
            </div>
        </div>
        } @for (section of sections; track $index) {
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-column psic-gap-4">
                <mat-icon [svgIcon]="section.icon" class="card-description mat-icon-64"></mat-icon>
                <h6>{{ section.title }}</h6>
            </div>
            <div class="d-flex flex-column psic-gap-3 right-content">
                @if (section.columns?.length) {
                <div class="row">
                    @for (col of section.columns; track $index) {
                    <div
                        class="caption-bold"
                        [class.text-end]="$index > 0"
                        [class.col]="$index === 0 || $index === 3"
                        [class.col-2]="$index === 1 || $index === 2"
                    >
                        {{ col }}
                    </div>

                    }
                </div>

                }
                <ng-container
                    *ngTemplateOutlet="collapsibleSectionFields; context: { section: section }"
                ></ng-container>
                @if (shouldShowToggle(section)) {
                <div class="d-flex justify-content-start w-100">
                    <lib-button
                        [buttonType]="'borderless'"
                        [buttonText]="getToggleLabel(section)"
                        [libIcon]="getToggleIcon(section)"
                        (callback)="toggleSection(section)"
                    ></lib-button>
                </div>
                }
            </div>
        </div>
        @if (!$last || hasItems) {
        <div class="separator"></div>
        } } } }

        <!-- Repeating items layout -->
        @if (hasItems) { @if (isCompact()) { @for (item of items; track $index) { @if (shouldShowTypeSeparator(item,
        $index)) {
        <div class="separator"></div>
        }
        <div class="d-flex flex-column psic-gap-6">
            <div class="d-flex flex-row align-items-center psic-gap-4">
                @if (shouldShowIcon(item, $index)) { @if (item.icon) {
                <mat-icon [svgIcon]="item.icon" class="card-description mat-icon-64"></mat-icon>
                } @if (item.label) {
                <h6>{{ item.label }}</h6>
                } }
            </div>

            <ng-container *ngTemplateOutlet="fieldsList; context: { $implicit: item.fields }"></ng-container>
        </div>
        @if (!$last) {
        <div class="separator"></div>
        } } } @else { @if (hasColumns) {
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-column"></div>
            <div class="d-flex flex-column psic-gap-5 right-content">
                <ng-container *ngTemplateOutlet="columnHeaders"></ng-container>
            </div>
        </div>
        } @for (item of items; track $index) { @if (shouldShowTypeSeparator(item, $index)) {
        <div class="separator"></div>
        } @if ($first) {
        <div class="d-flex flex-row justify-content-between align-items-start">
            <div class="d-flex flex-column psic-gap-4 left-icon-section">
                @if (shouldShowIcon(item, $index)) { @if (item.icon) {
                <mat-icon [svgIcon]="item.icon" class="card-description mat-icon-64"></mat-icon>
                } @if (item.label) {
                <h6>{{ item.label }}</h6>
                } }
            </div>
            <div class="d-flex flex-column psic-gap-2 right-content">
                <h6>{{ item.title }}</h6>
                <ng-container *ngTemplateOutlet="fieldsList; context: { $implicit: item.fields }"></ng-container>
            </div>
        </div>
        } @else {
        <div class="d-flex flex-row justify-content-between item-with-separator">
            <div class="d-flex flex-column psic-gap-4 left-icon-section">
                @if (shouldShowIcon(item, $index)) { @if (item.icon) {
                <mat-icon [svgIcon]="item.icon" class="card-description mat-icon-64"></mat-icon>
                } @if (item.label) {
                <h6>{{ item.label }}</h6>
                } }
            </div>
            <div class="d-flex flex-column psic-gap-2 right-content">
                @if (shouldShowSeparatorTopForItemType(item, $index)) {
                <div class="separator-top"></div>
                }
                <h6>{{ item.title }}</h6>
                <ng-container *ngTemplateOutlet="fieldsList; context: { $implicit: item.fields }"></ng-container>
            </div>
        </div>
        } } } }
    </div>
    }
</div>
